/* cw-locations-editor — owner editing for the Locations section.
 *
 * Closes the last gap in edit-website mode: the section has rendered from the
 * shop metafield custom.locations since it was built, but the only way to change
 * it was the Shopify metafield editor (raw JSON, no validation, easy to corrupt).
 *
 * Unlock: the site-wide edit switch (admin Keys tab) or ?cwedit=1 / ?edit=1.
 * Auth and the password prompt are cw-admin-gate.js, exactly as cw-slot-editor
 * and the gallery use them, so the owner is asked at most once per tab.
 *
 * Data is READ FROM THE PROXY when the panel opens, not embedded in the page:
 * the page must not carry an editing payload for every visitor, and re-reading
 * means a second tab's save cannot be silently clobbered by stale state.
 *
 * Class names deliberately avoid "-card" and "__card". cw-theme-base.css has
 * [data-theme="dark"] [class*="-card"] { background:#1f2937 !important } which
 * matches the whole class attribute as a string — it has already eaten a badge
 * pill and painted a map overlay opaque in this theme. Same reason nothing here
 * that needs its own colour is a <span>: .cw-main span is forced to #d1d5db.
 */
(function () {
  if (!window.cwAdminGate) return;

  var params = new URLSearchParams(location.search);
  var wants = params.get('cwedit') === '1' || params.get('edit') === '1' ||
              location.hash.indexOf('cwedit') >= 0 ||
              window.cwAdminGate.isEditing();
  if (!wants) return;

  var section = document.getElementById('locations');
  if (!section) return;

  var PROXY = 'https://cyclewash-admin-proxy.vvlars.workers.dev/rest/graphql.json';
  var SHOP_GID = 'gid://shopify/Shop/27217166471';
  var STATUSES = ['active', 'planned', 'hidden'];
  var pw = null;
  var rows = [];

  function gql(query, variables) {
    return fetch(PROXY, {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'X-CW-Admin-Pass': pw },
      body: JSON.stringify({ query: query, variables: variables || {} })
    }).then(function (r) {
      if (r.status === 401 || r.status === 403) throw new Error('Wrong admin password.');
      if (!r.ok) throw new Error('Proxy HTTP ' + r.status);
      return r.json();
    }).then(function (d) {
      if (d.errors && d.errors.length) throw new Error(d.errors[0].message);
      return d.data;
    });
  }

  function auth() {
    if (pw) return Promise.resolve(true);
    return window.cwAdminGate.getPass('Edit locations').then(function (v) {
      if (!v) return false;
      pw = v;
      return true;
    });
  }

  var css = document.createElement('style');
  css.textContent = [
    '.cwloce-open{display:inline-flex;align-items:center;gap:7px;margin:0 auto 26px;padding:8px 18px;border-radius:100px;cursor:pointer;font:600 13px Inter,sans-serif;background:rgba(255,195,0,.1);color:#FFC300;border:1px solid rgba(255,195,0,.5)}',
    '.cwloce-openwrap{display:flex;justify-content:center}',
    '.cwloce-modal{position:fixed;inset:0;z-index:100050;background:rgba(6,9,14,.9);display:none;flex-direction:column;padding:3vh 3vw;font:14px Inter,sans-serif}',
    '.cwloce-modal.open{display:flex}',
    '.cwloce-head{display:flex;gap:12px;align-items:center;margin-bottom:14px;color:#fff;font-weight:600;flex-wrap:wrap}',
    '.cwloce-head .cwloce-sp{margin-left:auto;display:flex;gap:8px}',
    '.cwloce-btn{font:600 13px Inter,sans-serif;border:0;border-radius:8px;padding:9px 16px;cursor:pointer}',
    '.cwloce-save{background:#FFC300;color:#14181f}.cwloce-save:disabled{opacity:.45;cursor:default}',
    '.cwloce-ghost{background:transparent;color:#c5ccd8;border:1px solid #26303f}',
    '.cwloce-add{background:#1E82C8;color:#fff}',
    '.cwloce-list{flex:1;overflow:auto;display:flex;flex-direction:column;gap:12px}',
    '.cwloce-row{background:#141b28;border:1px solid #26303f;border-radius:12px;padding:14px 16px;display:grid;gap:10px;grid-template-columns:repeat(auto-fit,minmax(160px,1fr))}',
    '.cwloce-row.is-hidden{opacity:.5}',
    '.cwloce-f{display:flex;flex-direction:column;gap:4px}',
    '.cwloce-f label{font:600 10.5px Inter,sans-serif;letter-spacing:.09em;text-transform:uppercase;color:#8b97a8}',
    '.cwloce-f input,.cwloce-f select,.cwloce-f textarea{font:13px Inter,sans-serif;background:#0d1420;color:#f4f7fb;border:1px solid #26303f;border-radius:7px;padding:8px 10px;width:100%;box-sizing:border-box}',
    '.cwloce-f textarea{min-height:56px;resize:vertical}',
    '.cwloce-f input:focus,.cwloce-f select:focus,.cwloce-f textarea:focus{outline:0;border-color:#1E82C8}',
    '.cwloce-bad{border-color:#e5534b !important}',
    '.cwloce-tools{display:flex;gap:6px;align-items:flex-end;grid-column:1/-1;justify-content:flex-end}',
    '.cwloce-tools button{font:600 12px Inter,sans-serif;background:transparent;color:#9fb3c8;border:1px solid #26303f;border-radius:7px;padding:6px 11px;cursor:pointer}',
    '.cwloce-tools .cwloce-del{color:#ff6b81;border-color:rgba(255,107,129,.4)}',
    '.cwloce-msg{color:#9fb3c8;font-size:12.5px}',
    '.cwloce-msg.err{color:#ff6b81}.cwloce-msg.ok{color:#3fbf6f}',
    '.cwloce-chk{flex-direction:row;align-items:center;gap:7px}',
    '.cwloce-chk input{width:auto}'
  ].join('\n');
  document.head.appendChild(css);

  var modal = document.createElement('div');
  modal.className = 'cwloce-modal';
  modal.innerHTML =
    '<div class="cwloce-head"><b>Locations</b>' +
    '<div class="cwloce-msg" id="cwloce-msg">loading…</div>' +
    '<div class="cwloce-sp">' +
    '<button class="cwloce-btn cwloce-add" id="cwloce-add">+ Add location</button>' +
    '<button class="cwloce-btn cwloce-save" id="cwloce-save">Save</button>' +
    '<button class="cwloce-btn cwloce-ghost" id="cwloce-close">Close</button>' +
    '</div></div><div class="cwloce-list" id="cwloce-list"></div>';
  document.body.appendChild(modal);

  var listEl = modal.querySelector('#cwloce-list');
  var msgEl = modal.querySelector('#cwloce-msg');

  function say(text, kind) {
    msgEl.textContent = text;
    msgEl.className = 'cwloce-msg' + (kind ? ' ' + kind : '');
  }

  function field(label, value, key, type) {
    var wrap = document.createElement('div');
    wrap.className = 'cwloce-f';
    var l = document.createElement('label');
    l.textContent = label;
    var input;
    if (type === 'select') {
      input = document.createElement('select');
      STATUSES.forEach(function (s) {
        var o = document.createElement('option');
        o.value = s; o.textContent = s;
        if (s === value) o.selected = true;
        input.appendChild(o);
      });
    } else if (type === 'textarea') {
      input = document.createElement('textarea');
      input.value = value || '';
    } else if (type === 'checkbox') {
      wrap.className = 'cwloce-f cwloce-chk';
      input = document.createElement('input');
      input.type = 'checkbox';
      input.checked = !!value;
    } else {
      input = document.createElement('input');
      input.type = 'text';
      input.value = value || '';
    }
    input.dataset.k = key;
    wrap.appendChild(type === 'checkbox' ? input : l);
    wrap.appendChild(type === 'checkbox' ? l : input);
    return wrap;
  }

  /* machines are [{id,t}]; edited as one "ID | Title" per line — a nested
     repeater for a list that is usually 0-2 entries is not worth the code. */
  function machinesToText(m) {
    return (m || []).map(function (x) {
      return (x.id || '') + (x.t ? ' | ' + x.t : '');
    }).join('\n');
  }
  function textToMachines(t) {
    return String(t || '').split('\n').map(function (l) { return l.trim(); })
      .filter(Boolean).map(function (l) {
        var p = l.split('|');
        return { id: p[0].trim(), t: (p[1] || '').trim() };
      }).filter(function (x) { return x.id; });
  }

  function draw() {
    listEl.textContent = '';
    rows.forEach(function (it, i) {
      var row = document.createElement('div');
      row.className = 'cwloce-row' + (it.s === 'hidden' ? ' is-hidden' : '');
      row.appendChild(field('City *', it.c, 'c'));
      row.appendChild(field('Country', it.co, 'co'));
      row.appendChild(field('Flag', it.f, 'f'));
      row.appendChild(field('Status', it.s || 'active', 's', 'select'));
      row.appendChild(field('Headquarters', it.hq, 'hq', 'checkbox'));
      row.appendChild(field('Address', it.a, 'a'));
      row.appendChild(field('Map search (optional)', it.q, 'q'));
      row.appendChild(field('Machines — one per line, ID | Title', machinesToText(it.m), 'm', 'textarea'));

      var tools = document.createElement('div');
      tools.className = 'cwloce-tools';
      [['↑', -1], ['↓', 1]].forEach(function (p) {
        var b = document.createElement('button');
        b.type = 'button'; b.textContent = p[0];
        b.onclick = function () {
          var j = i + p[1];
          if (j < 0 || j >= rows.length) return;
          collect();
          var tmp = rows[i]; rows[i] = rows[j]; rows[j] = tmp;
          draw();
        };
        tools.appendChild(b);
      });
      var del = document.createElement('button');
      del.type = 'button'; del.className = 'cwloce-del'; del.textContent = 'Delete';
      del.onclick = function () {
        if (!confirm('Delete ' + (it.c || 'this location') + '?')) return;
        collect(); rows.splice(i, 1); draw();
      };
      tools.appendChild(del);
      row.appendChild(tools);
      listEl.appendChild(row);
    });
    say(rows.length + ' location' + (rows.length === 1 ? '' : 's'));
  }

  /* read the DOM back into rows — called before any reorder/delete/save so
     typing is never lost by a redraw */
  function collect() {
    var els = listEl.querySelectorAll('.cwloce-row');
    rows = Array.prototype.map.call(els, function (row) {
      var o = {};
      row.querySelectorAll('[data-k]').forEach(function (inp) {
        var k = inp.dataset.k;
        if (k === 'hq') { if (inp.checked) o.hq = true; return; }
        if (k === 'm') { var m = textToMachines(inp.value); if (m.length) o.m = m; return; }
        var v = inp.value.trim();
        if (v) o[k] = v;
      });
      if (!o.s) o.s = 'active';
      if (!o.m) o.m = [];
      return o;
    });
  }

  function load() {
    say('loading…');
    return gql('{ shop { metafield(namespace:"custom", key:"locations"){ value } } }')
      .then(function (d) {
        var mf = d.shop && d.shop.metafield;
        rows = mf && mf.value ? JSON.parse(mf.value) : [];
        if (!Array.isArray(rows)) rows = [];
        draw();
      });
  }

  modal.querySelector('#cwloce-close').onclick = function () {
    modal.classList.remove('open');
  };

  modal.querySelector('#cwloce-add').onclick = function () {
    collect();
    rows.push({ c: '', co: '', f: '', s: 'planned', m: [] });
    draw();
    listEl.lastChild.scrollIntoView({ block: 'center' });
  };

  modal.querySelector('#cwloce-save').onclick = function () {
    collect();
    /* city is the only hard requirement — the section skips entries without one,
       so saving a blank row would silently drop it */
    var bad = null;
    listEl.querySelectorAll('.cwloce-row').forEach(function (row, i) {
      var c = row.querySelector('[data-k="c"]');
      c.classList.toggle('cwloce-bad', !c.value.trim());
      if (!c.value.trim() && bad === null) bad = i;
    });
    if (bad !== null) { say('Row ' + (bad + 1) + ' needs a city.', 'err'); return; }

    var btn = this;
    btn.disabled = true;
    say('saving…');
    gql('mutation($m:[MetafieldsSetInput!]!){ metafieldsSet(metafields:$m){ userErrors{ field message } } }',
      { m: [{ ownerId: SHOP_GID, namespace: 'custom', key: 'locations',
              type: 'json', value: JSON.stringify(rows) }] })
      .then(function (d) {
        var errs = ((d.metafieldsSet || {}).userErrors) || [];
        if (errs.length) throw new Error(errs[0].message);
        say('saved — reloading', 'ok');
        setTimeout(function () { location.reload(); }, 700);
      })
      .catch(function (e) {
        btn.disabled = false;
        say(e.message, 'err');
      });
  };

  var wrap = document.createElement('div');
  wrap.className = 'cwloce-openwrap';
  var open = document.createElement('button');
  open.type = 'button';
  open.className = 'cwloce-open';
  open.textContent = '✎ Edit locations';
  open.onclick = function () {
    auth().then(function (ok) {
      if (!ok) return;
      modal.classList.add('open');
      return load();
    }).catch(function (e) { say(e.message, 'err'); });
  };
  wrap.appendChild(open);

  var lede = section.querySelector('.cw-loc__lede');
  if (lede && lede.parentNode) lede.parentNode.insertBefore(wrap, lede.nextSibling);
  else section.insertBefore(wrap, section.firstChild);
})();
